var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',{attrs:{"group-id":_vm.$route.params.code}})}
var staticRenderFns = []

export { render, staticRenderFns }